<template>
    <el-upload
            ref="up"
            :action="action"
            :data="uploadParam"
            :accept="accept"
            :list-type="listType"
            :file-list="fileList"
            :on-change="handleChange"
            :on-success="handleSuccess"
            :on-remove="handleRemoveFile"
            :before-upload="uploadAuth"
            :auto-upload="false">
        <div class="upload-info">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">{{$t('drag_file')}}</div>
            <div slot="tip" class="el-upload__tip" v-if="tip">{{tip}}</div>

        </div>
    </el-upload>

</template>

<script>
    import {auth} from '@/api/space/file';
    import {suffix} from '@/util/files';
    import {mapGetters} from 'vuex'
    export default {
        name: '',
        props: {
            tip: {
                type: String,
                default: ''
            },
            accept: {
                type: String,
                default: ''
            },
            listType: {
                type: String,
                default: 'picture-card'
            },
            urls: {
                type: Array,
                default: () => []
            },
            uploadSuccess: {
                type: Function,
                default: null,
            }
        },
        components: {},
        computed: {
            ...mapGetters(['employee'])
        },
        mounted: function () {
            this.setUrls(this.urls)
        },
        data: function () {
            return {
                fileList: [],
                fileUidUrls: [],
                action: '',
                totalFiles: 0,
                file: {
                    url: '',
                    name: ''
                },
                dirUuid: '',
                uploadParam: {},
                upUrls: []
            }
        },
        methods: {
            uploadAuth(file) {
                let suffixName = suffix(file.name);
                let type = this._fileType(suffixName)
                let {size, name, uid} = file
                let employeeName = this.employee.name
                let dirUuid = this.dirUuid
                return auth({size, type, employeeName, name, dirUuid}).then(res => {
                    if (res.code == 0) {
                        let fileId = res.data.fileId
                        let {host, expire, policy, accessId, signature, dir, callback} = res.data.policy
                        let param = {
                            'key': dir + fileId,
                            policy,
                            'OSSAccessKeyId': accessId,
                            'success_action_status': '200', //让服务端返回200,不然，默认会返回204
                            signature,
                            callback,
                            expire
                        }
                        this.fileUidUrls.push({uid: uid, url: host + dir + fileId})
                        this.action = host
                        this.uploadParam = param

                    } else {
                        return new Promise.reject()
                    }
                }).catch(() => {
                    return new Promise.reject()
                })
            },

            handleUpload(){
                this.fileUidUrls = []
                this.$refs.up.submit()
                if (this.totalFiles === this.upUrls.length && this.uploadSuccess) {
                    this.uploadSuccess(this.upUrls)
                }
            },

            handleChange(file, fileList) {
                this.totalFiles = fileList.length
            },

            handleRemoveFile(file){
                for (let i = 0; i < this.fileList.length; i++) {
                    if (this.fileList[i].url === file.url) {
                        this.fileList.splice(i, 1)
                        this.upUrls.splice(i, 1)
                        if (this.totalFiles === 0) {
                            this.totalFiles = this.upUrls.length
                        } else {
                            this.totalFiles--
                        }
                        return
                    }
                }
            },

            setUrls(urls){
                this.fileList = []
                this.upUrls = []
                for (let i = 0; i < urls.length; i++) {
                    this.fileList.push({name: i + '', url: urls[i]})
                    this.upUrls.push(urls[i])
                }
            },


            handleSuccess(response, file, fileList){
                this.fileUidUrls.forEach((element, index) => {
                        this.upUrls.push(element.url)
                        this.fileList.push({name: this.fileList.length + '', url: element.url})
                });
                if (fileList.length === this.upUrls.length && this.uploadSuccess) {
                    this.uploadSuccess(this.upUrls)
                }

            },

            _fileType(suffix) {
                let imgTypes = ['.jpg', '.jpeg', '.png', '.gif']
                let videoTypes = [".rmvb", ".rm", ".wmv", ".avi", ".3gp", ".mp4"]
                let audioTypes = [".wav", ".midi", ".cda", ".mp3", ".wma"]
                let type = 4
                if (imgTypes.indexOf(suffix.toLowerCase()) >= 0) {
                    type = 1
                } else if (videoTypes.indexOf(suffix.toLowerCase()) >= 0) {
                    type = 2
                } else if (audioTypes.indexOf(suffix.toLowerCase()) >= 0) {
                    type = 3
                }

                return type
            },
        },
    }
</script>

<style lang="scss">
    .el-upload {
        width: 100%;
        height: 100%;
        .el-upload-dragger {
            background-color: transparent;
            min-height: 180px;
            height: 100%;
            width: 100%;

        }

        .upload-info {
            .el-icon-upload {
                margin: 0;
                margin-bottom: 10px;
            }
            height: 100%;
            display: flex;
            text-align: center;
            justify-content: center;
            align-content: center;
            flex-direction: column;
        }
    }

    .el-upload--picture-card {
        background-color: transparent;
    }


</style>
